import React from 'react'

function GridImage() {
  return (
    <div className="relative space-y-4">
      <div className="flex items-end justify-center lg:justify-start space-x-6">
        <picture>
          <source
            media="(max-width:600px)"
            srcSet={`https://ik.imagekit.io/gubelinlab/tr:w-128,h-192,f-auto/judi-bola-online.webp`}
          />
          <source
            media="(min-width:640px)"
            srcSet={`https://ik.imagekit.io/gubelinlab/tr:w-224,h-336,f-auto/judi-bola-online.webp`}
          />
          <img
            title={`judi bola online`}
            alt={`judi bola online`}
            src={`data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=`}
            data-src="https://ik.imagekit.io/gubelinlab/tr:w-224,h-336,f-auto/judi-bola-online.webp"
            className="rounded-3xl shadow-lg w-32 md:w-56 blur-up lazyload"
          />
        </picture>

        <picture>
          <source
            media="(max-width:600px)"
            srcSet={`https://ik.imagekit.io/gubelinlab/tr:w-160,h-107,f-auto/judi-slot-online.webp`}
          />
          <source
            media="(min-width:640px)"
            srcSet={`https://ik.imagekit.io/gubelinlab/tr:w-256,h-171,f-auto/judi-slot-online.webp`}
          />
          <img
            title={`judi slot online`}
            alt={`judi slot online`}
            src={`data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=`}
            data-src="https://ik.imagekit.io/gubelinlab/tr:w-256,h-171,f-auto/judi-slot-online.webp"
            className="rounded-3xl shadow-lg w-40 md:w-64 blur-up lazyload"
          />
        </picture>
      </div>
      <div className="flex items-start justify-center lg:justify-start space-x-6 ml-14">
        <picture>
          <source
            media="(max-width:600px)"
            srcSet={`https://ik.imagekit.io/gubelinlab/tr:w-96,h-120,f-auto/judi-poker-online.webp`}
          />
          <source
            media="(min-width:640px)"
            srcSet={`https://ik.imagekit.io/gubelinlab/tr:w-160,h-200,f-auto/judi-poker-online.webp`}
          />
          <img
            title={`judi poker online`}
            alt={`judi poker online`}
            src={`data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=`}
            data-src="https://ik.imagekit.io/gubelinlab/tr:w-160,h-200,f-auto/judi-poker-online.webp"
            className="rounded-3xl shadow-lg w-24 md:w-40 blur-up lazyload"
          />
        </picture>

        <picture>
          <source
            media="(max-width:600px)"
            srcSet={`https://ik.imagekit.io/gubelinlab/tr:w-128,h-188,f-auto/judi-casino-online.webp`}
          />
          <source
            media="(min-width:640px)"
            srcSet={`https://ik.imagekit.io/gubelinlab/tr:w-224,h-329,f-auto/judi-casino-online.webp`}
          />
          <img
            title={`judi casino online`}
            alt={`judi casino online`}
            src={`data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=`}
            data-src="https://ik.imagekit.io/gubelinlab/tr:w-224,h-329,f-auto/judi-casino-online.webp"
            className="rounded-3xl shadow-lg w-32 md:w-56 blur-up lazyload"
          />
        </picture>
      </div>
    </div>
  )
}

export default GridImage
